export default {
  overseasMembershipCodes: ["OUKA", "OVER"],
  studentsMembershipCodes: ["STU", "STU1", "STU2", "STUA"],
  membersMembershipCodes: ["ORD", "COM", "STF"],
  loqateApiKey: "KF22-DK21-ZN94-HE22",
  currentMembershipYear: "2020/2022",
  joinOnlineIntro:
    "<p>The Society of Radiographers is the only organisation that truly represents the interests of everyone working in clinical imaging, radiotherapy and oncology.<br><b>For the full lists of benefits for SoR membership <a href='/members-benefits'>Click here</a>.</b><br><em>If you are employed as an Associate Professional, or need further advice on which category to join under, please contact our Membership Dept on 020 7740 7200 who will be able to advise.</em></p>",
  titles: {
    Mr: "Mr",
    Mrs: "Mrs",
  },
  universities: {
    SHE: "Sheffield Hallam University",
    ULS: "University of Ulster",
    WRE: "Bangor University",
    QOUK: "Qualified outside the UK",
  },
  disciplines: {
    D: "Diagnostic",
    T: "Therapy",
  },
  countries: {
    GBR: "United Kingdom",
    USA: "United States of America",
  },
  genders: {
    F: "Female",
    M: "Male",
    NB: "Non Binary",
    U: "Unspecified",
  },
  qualificationsOnEntry: {
    AHE: "Access To Higher Education",
    BTEC: "B-Tech",
    GRAD: "Graduate Entry",
  },
  courses: {
    BSC: "BSC(Hons)",
    FBSC: "Foundation Course leading to BSC",
  },
  fullPartTime: {
    F: "Full Time",
    P: "Part Time",
  },
  pointsOfEntry: {
    Y1: "Year 1",
    Y2: "Year 2",
  },
  membershipStatuses: {
    ORD: "Ordinary",
    STU: "Student",
    STU1: "Student 1st Year",
  },
  ethnicities: {
    A1: "White British",
    A2: "Other White Background",
  },
  nationalities: {
    0: "British",
    1: "English",
  },
  fees: [
    {
      annualRate: 294,
      monthlyRate: 24.5,
      memTypeCode: "MEM",
      memStatusCode: "ORD",
      description:
        "Cras risus ipsum, faucibus ut, ullamcorper id, varius ac, leo. Praesent ut ligula non mi varius sagittis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.",
      title: "Qualified Radiographer",
      getStartedContent:
        '<p>Thanks for choosing the <b>Qualified Radiographer membership</b></p>\r\n\r\n<p>Registration only takes 5-10mins.</p>\r\n\r\n<p>You can see the full list of membership benefits by <a href="https://www.google.com" target="_blank"><b>clicking here</b></a></p>\r\n',
      message:
        "<h4>Have you qualified within the last 2 years?</h4><p>If you completed your qualification within the last 2 years you may be eligible for our New Professionals rate. This will be applied automatically during registration.</p>",
      additionalAnnualRate: 159,
      additionalMonthlyRate: 35,
    },
    {
      annualRate: 45,
      monthlyRate: 3.75,
      memTypeCode: "MEM",
      memStatusCode: "STU",
      description:
        "Cras risus ipsum, faucibus ut, ullamcorper id, varius ac, leo. Praesent ut ligula non mi varius sagittis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.",
      title: "Student",
      getStartedContent:
        '<p>Thanks for choosing the <b>Student</b></p>\r\n\r\n<p>Registration only takes 5-10mins.</p>\r\n\r\n<p>You can see the full list of membership benefits by <a href="https://www.google.com" target="_blank"><b>clicking here</b></a></p>\r\n',
    },
    {
      annualRate: 90,
      monthlyRate: 7.5,
      memTypeCode: "MEM",
      memStatusCode: "RAS",
      description:
        "Cras risus ipsum, faucibus ut, ullamcorper id, varius ac, leo. Praesent ut ligula non mi varius sagittis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.",
      title: "Assistant",
      getStartedContent:
        '<p>Thanks for choosing the <b>Assistant</b></p>\r\n\r\n<p>Registration only takes 5-10mins.</p>\r\n\r\n<p>You can see the full list of membership benefits by <a href="https://www.google.com" target="_blank"><b>clicking here</b></a></p>\r\n',
    },
    {
      annualRate: 138,
      monthlyRate: 11.5,
      memTypeCode: "MEM",
      memStatusCode: "OVER",
      description:
        "Cras risus ipsum, faucibus ut, ullamcorper id, varius ac, leo. Praesent ut ligula non mi varius sagittis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.",
      title: "International",
      getStartedContent:
        '<p>Thanks for choosing the <b>International</b></p>\r\n\r\n<p>Registration only takes 5-10mins.</p>\r\n\r\n<p>You can see the full list of membership benefits by <a href="https://www.google.com" target="_blank"><b>clicking here</b></a></p>\r\n',
    },
    {
      annualRate: 129,
      monthlyRate: 10.75,
      memTypeCode: "MEM",
      memStatusCode: "APR",
      description:
        "Cras risus ipsum, faucibus ut, ullamcorper id, varius ac, leo. Praesent ut ligula non mi varius sagittis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.",
      title: "Apprentice",
      getStartedContent:
        '<p>Thanks for choosing the <b>Apprentice</b></p>\r\n\r\n<p>Registration only takes 5-10mins.</p>\r\n\r\n<p>You can see the full list of membership benefits by <a href="https://www.google.com" target="_blank"><b>clicking here</b></a></p>\r\n',
    },
    {
      annualRate: 69,
      monthlyRate: 5.75,
      memTypeCode: "MEM",
      memStatusCode: "RET",
      description:
        "Cras risus ipsum, faucibus ut, ullamcorper id, varius ac, leo. Praesent ut ligula non mi varius sagittis. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem.",
      title: "Retired",
    },
    {
      memTypeCode: "STF",
      memStatusCode: "STF",
      description: "Staff",
      title: "Staff",
    },
  ],
  memWhereFoundTypes: {
    5: "Conference or event",
    3: "Online Search",
    6: "Other",
    1: "Recommendation from friend, relative or colleague",
    4: "Social Media Advert",
    2: "SoR presentation at University",
  },
};
